"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logError = logError;

/**
 * Unclear purpose function for logging errors to Rollbar.
 * @deprecated Use/create loggerService instead
 */
function logError(error) {
  // eslint-disable-next-line no-console
  console.log(error);

  try {
    window.Rollbar.error(error);
  } catch (_unused) {}
}